/**
 * Plural categories supported by Phrase
 *
 * e.g.:
 *
 * ```json
 * "page.qualification_profiles.employee_status.expired_count": {
 *   "zero":  "No qualifications expired",
 *   "one":   "{{number}} qualification expired",
 *   "other": "{{number}} qualifications expired"
 * }
 * ```
 */
export const PLURAL_CATEGORIES = ['zero', 'one', 'other'] as const;
export type PluralCategory = (typeof PLURAL_CATEGORIES)[number];

/**
 * Selects the Phrase plural sub-key
 */
export function selectPluralCategory(count: number): PluralCategory {
  if (count === 0) {
    return 'zero';
  }
  if (count === 1) {
    return 'one';
  }
  return 'other';
}

/**
 * Builds the fully-qualified Phrase key for `count`, e.g. `base.one`.
 *
 * ```ts
 * translateService.instant(pluralKey(base, count), { count });
 * ```
 */
export function pluralKey(base: string, count: number): string {
  return `${base}.${selectPluralCategory(count)}`;
}
